import type { SignQuoteRequest } from '@saiens/shared/types';

type BuildSignPayloadParams = {
  signature: string;
  signedByName: string;
  signedByEmail: string;
  sameAsPartner: boolean;
  invoiceCompanyName: string;
  invoiceVat: string;
  invoiceAddress: string;
  invoiceEmail: string;
  needsContactInfo: boolean;
  contactName: string;
  contactPhone: string;
};

const normalizePhone = (phone: string) => phone.replace(/[\s()-]/g, '');

export function isValidPhone(phone: string): boolean {
  return /^\d{8,15}$/.test(normalizePhone(phone));
}

export function buildSignPayload({
  signature,
  signedByName,
  signedByEmail,
  sameAsPartner,
  invoiceCompanyName,
  invoiceVat,
  invoiceAddress,
  invoiceEmail,
  needsContactInfo,
  contactName,
  contactPhone,
}: BuildSignPayloadParams): SignQuoteRequest {
  return {
    signature,
    signed_by_name: signedByName,
    signed_by_email: signedByEmail || undefined,
    ...(needsContactInfo
      ? {
          contact_info: {
            name: contactName.trim(),
            phone: normalizePhone(contactPhone),
          },
        }
      : {}),
    invoice_info: {
      same_as_partner: sameAsPartner,
      company_name: invoiceCompanyName || undefined,
      vat: invoiceVat || undefined,
      address: invoiceAddress || undefined,
      email: invoiceEmail || undefined,
    },
  };
}
